import {Component} from '@angular/core';
import {AlertController, NavController, NavParams} from 'ionic-angular';
import { UUID } from 'angular2-uuid';

import {LoginPage} from '../login/login';

import {EnumNames, Familienstand} from '../../model/enums';
import {Sterbefall} from '../../model/sterbefall';
import {Person} from '../../model/person';

import {TerminPage} from '../termin/termin';
import {VerwandterPage} from '../verwandter/verwandter';

import { GuiProvider } from '../../providers/gui.provider';
import { SterbefallProvider } from '../../providers/sterbefall.provider';
import { UserProvider } from '../../providers/user.provider';
import {ServerProvider} from "../../providers/server.provider";


@Component({
	templateUrl: 'sterbefall.html'
})
export class SterbefallPage {

	isNew: boolean;
	sterbefall: Sterbefall;

	timer: any;

	constructor(
		public nav: NavController,
		navParams: NavParams,
		public guiProvider : GuiProvider,
		public sterbefallProvider: SterbefallProvider,
		public userProvider : UserProvider,
		public serverProvider: ServerProvider,
		public alertController : AlertController)
	{
		let s = navParams.get('sterbefall');
		this.isNew = (s == null);
		if (this.isNew) {
			this.sterbefall = new Sterbefall();
			this.sterbefall.id = UUID.UUID();
		}
		else {
			this.sterbefall = Object.assign(new Sterbefall(), s); //working copy
		}
		//Im Service speichern als aktuellen Sterbefall
		this.sterbefallProvider.aktuellerSterbefall = this.sterbefall;
	}

	ionViewWillEnter() {
		//alle 30 Sekunden automatisch speichern
		var self = this;
		this.timer = setInterval(function() { self.save() }, 30000);
	}

	ionViewWillLeave() {
		//beim Verlassen der Seite Timer ausschalten und automatisch speichern
		clearInterval(this.timer);
		this.save();
	}

	/**
	 * Öffnet die Formularansicht für die Eingabe eines neuen Verwandten.
	 */
	newVerwandter() {
		this.openVerwandter(undefined);
	}

	/**
	 * Öffnet den gegebenen Verwandten in der Formularansicht.
	 */
	openVerwandter(verwandterIndex: number) {
		this.nav.push(VerwandterPage, { "verwandter-index": verwandterIndex });
	}

	/**
	 * Löscht nach Rückfrage den gegebenen Verwandten.
	 */
	deleteVerwandter(verwandterIndex: number) {
		this.guiProvider.showAlertYesOrNo("Löschen", "Diesen Verwandten wirklich löschen?",
			() => { this.sterbefall.verwandte.splice(verwandterIndex, 1); }, () => {});
	}

	/**
	 * Öffnet die Formularansicht für die Eingabe eines neuen Termins.
	 */
	newTermin() {
		this.openTermin(undefined);
	}

	/**
	 * Öffnet den gegebenen Termin in der Formularansicht.
	 */
	openTermin(terminIndex: number) {
		this.nav.push(TerminPage, { "termin-index": terminIndex });
	}

	/**
	 * Löscht nach Rückfrage den gegebenen Termin.
	 */
	deleteTermin(terminIndex: number) {
		this.guiProvider.showAlertYesOrNo("Löschen", "Diesen Termin wirklich löschen?",
			() => { this.sterbefall.termine.splice(terminIndex, 1); }, () => {});
	}

	/**
	 * Speichert den aktuellen Sterbefall.
	 */
	save() {
		this.sterbefallProvider.saveSterbefall(this.sterbefall);
	}

	/**
	 * Speichert den aktuellen Sterbefall und sendet ihn an den
	 * RuheSanft-Server.
	 */
	send() {
		//Login überprüfen, ggf. auf Login-Seite weiterleiten
		if (false == this.userProvider.isLoggedIn()) {
			//Login fehlt
			this.guiProvider.showAlertAndPush('Anmeldung nötig',
				'Um einen Sterbefall übermitteln zu können, melden Sie sich bitte zunächst an',
				LoginPage);
		}
		else {
			//Login vorhanden. Senden.
			this.serverProvider.uploadSterbefall(this.sterbefall);
		}
	}

	selectAngehoerigen(property: "anmelder" | "grabrecht" | "kostentraeger") {
    let alert = this.alertController.create();
    alert.setTitle('Angehörigen wählen');
		let angehoerige = this.sterbefall.getAngehoerige();
		for (let i = 0; i < angehoerige.length; i++)
			alert.addInput({type: 'radio', label: this.getAngehoerigerNameUndBezeichnung(angehoerige[i]), value: ''+i});
		alert.addInput({type: 'radio', label: 'Jemand anderes', value: 'extra'});
    alert.addButton({
    	text: 'Abbrechen',
    	role: 'cancel'
		});
    alert.addButton({
      text: 'OK',
      handler: value => {
				let source : any = undefined;
				if (value == 'extra')
					this.sterbefall[property] = new Person();
				else if (value != undefined)
					source = angehoerige[+value];
				if (source) {
					this.sterbefall[property] = source;
				}
			}
    });
		alert.present();
	}

	/** Gibt z.B. "Matthias Wenger (Geschwister)" zurück. */
	getAngehoerigerNameUndBezeichnung(angehoeriger: Person) {
		if (angehoeriger.verwandtschaft) {
			let bezeichnung = this.verwandtschaftsArtNames[angehoeriger.verwandtschaft];
			return angehoeriger.nachname + ', ' + angehoeriger.vorname + ' (' + bezeichnung + ')';
		}
		else {
			return angehoeriger.nachname + ', ' + angehoeriger.vorname;
		}
	}

	adoptEhepartnerAnschrift() {
		let s = this.sterbefall;
		s.ehepartner.plz = s.verstorbener.plz;
		s.ehepartner.ort = s.verstorbener.ort;
		s.ehepartner.strasse = s.verstorbener.strasse;
	}

	isAngehoeriger(person: Person) {
		let s = this.sterbefall;
		let angehoerige = [s.ehepartner, s.vater, s.mutter].concat(s.verwandte);
		return (angehoerige.indexOf(person) > -1);
	}

	getAdminTitle() {
		if (this.sterbefall.isGeloescht())
			return "Wiederherstellen"
		else
			return "Freigabe";
	}

	//Anzeige des/der nächsten Verwandten
	get familienstand() { return this.sterbefall.verstorbener.familienstand }
	get familieShowEhepartner() { return [1, 3, 4, 5, 6, 7, 8].indexOf(+this.familienstand) > -1; }
	get familieShowEltern() { return this.familienstand == 2; }
	get familieTitleEhepartner() { return ([3, 5].indexOf(+this.familienstand) > -1 ? "Verstorbener " : "") + "Ehepartner"; }
	get familieTitleWohnort() { return ([3, 5].indexOf(+this.familienstand) > -1 ? "Letzter gemeinsamer " : "") + "Wohnort"; }

	//Anzeigen der Sterbedatum des Ehepartners
	get eheShowSterbedaten() { return [Familienstand.Verwitwet, Familienstand.FuerTotErklaert].indexOf(
		+this.familienstand) > -1; }

	//Anzeigen des Datums und Aktenzeichens zum Ende einer Ehe
	get eheShowEndeDaten() { return [Familienstand.Geschieden, Familienstand.Aufgehoben, Familienstand.FuerNichtigErklaert].indexOf(
		+this.familienstand) > -1; }

	get eheEndeDatumLabel() : string {
		if (this.familienstand == Familienstand.Geschieden)
			return "Scheidungsdatum";
		else if (this.familienstand == Familienstand.Aufgehoben)
			return "Ehe aufgehoben am";
		else if (this.familienstand == Familienstand.FuerNichtigErklaert)
			return "Ehe für nichtig erklärt am";
		return "???";
	}

	//helper
	get anredeNames() { return EnumNames.anredeNames; }
	get anredeNamesOhneFirma() { return EnumNames.anredeNamesOhneFirma; }
	get bestattungsArtNames() { return EnumNames.bestattungsArtNames; }
	get booleanOptNames() { return EnumNames.booleanOptNamesVorhanden; }
	get familienstandNames() { return EnumNames.familienstandNames; }
	get todesursacheNames() { return EnumNames.todesursacheNames; }
	get verfuegungArtNames() { return EnumNames.verfuegungArtNames; }
	get verwandtschaftsArtNames() { return EnumNames.verwandtschaftsArtNames; }
	get vormundNames() { return EnumNames.vormundNames; }

}



// WEBPACK FOOTER //
// ./src/pages/sterbefall/sterbefall.ts